<template>
<v-container>
  <v-card v-if="selectedprods" elevation="11" full-width light color="secondary">
    <v-card-title class="justify-center align-center"><h1 class="textTitle--text">{{ $t('cartlist.ScreenTitle') }}</h1></v-card-title>
      
      <v-simple-table
    fixed-header
    height="300px"
    class="tertiary"
  >
    <template v-slot:default>
      <thead>
        <tr>
            <th class="text-center quaterny">
                <h3 class="text--text">{{ $t('delete') }}</h3>
            </th>
          <th class="text-center quaterny" >
            <h3 class="text--text">{{ $t('headers.prodName') }}</h3>
          </th>
          <th class="text-center quaterny">
            <h3 class="text--text">{{ $t('code') }}</h3>
          </th>
          <th class="text-center quaterny">
            <h3 class="text--text">{{ $t('price') }}</h3>
          </th>
          <th class="text-center quaterny">
            <h3 class="text--text">{{ $t('qty') }}</h3>
          </th>
          <th class="text-center quaterny">
            <h3 class="text--text">{{ $t('total') }}</h3>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="prod in selectedprods"
          :key="prod.id"
        >
            <td><v-row class="align-center justify-center"><v-icon color="red darken-4" @click="removeProd(prod.id)">mdi-backspace-reverse</v-icon></v-row></td>
          <td><v-row class="align-center justify-center"><h3 class="brown--text text--darken-4 ">{{ prod.name }}</h3></v-row></td>
          <td><v-row class="align-center justify-center"><h3 class="brown--text text--darken-4 ">{{ prod.codigo }}</h3></v-row></td>
          <td width="75"><v-row class="align-center justify-center">
            <v-text-field min=0 class="font-weight-black" type="number" v-model.number="prod.pu" @change="getTotal"></v-text-field>
            </v-row></td>
          <td>
            <v-row class="align-center justify-center">
              <v-icon class="mx-2" @click="minusQty(prod)">mdi-minus</v-icon>
            <v-text-field min=0 :max="prod.currenttInv" class="font-weight-black" type="number" v-model.number="prod.qty" @change="getTotal"></v-text-field>
            <v-icon class="mx-2" @click="masQty(prod)">mdi-plus</v-icon>
            </v-row>
            </td>
        <td><v-row class="align-center justify-center"> <h3 class="brown--text text--darken-4 ">{{prod.total}}</h3></v-row></td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
  </v-card>
  <v-card v-if="selectedprods.length" elevation="8" class="ma-2 pa-2 secondary">
  
  
      <v-row class="pa-3 justify-center align-center"><h2>{{ $t('total') }}</h2>
      <v-chip
            class="ma-2 pa-2 font-weight-black"
            color="orange darken-4"
            dark
            label
            large
          >
            <h2>{{this.totalCart}}</h2>
          </v-chip>
          <v-btn @click="confirmCartDialog=true" class="mx-3 pa-2 success black--text font-weight-black">{{ $t('confirm') }}</v-btn>
          </v-row>
          <v-dialog v-model="confirmCartDialog" max-width="80%" :retain-focus="false">
            <v-row class="pa-5 align-center justify-center quaterny">
            <v-card elevation="11" class="pa-2 secondary" width="90%">
              <v-card-title class="align-center justify-center"><h1 class="textTitle--text">{{ $t('cartlist.confirmSaleTitle') }}</h1></v-card-title>
              <v-divider class="ma-3"></v-divider>
              <v-row class="ml-5 align-center justify-center">
                <v-card width="40%" elevation="11" class="ma-2 pa-2 tertiary">
              <v-row class="ml-5 align-center"><h2 class="mx-2">{{ $t('chooseclient.clientName') }}</h2><h2 class="mx-2 amber--text text--accent-2">{{this.client.name}}</h2></v-row>
              <v-row class="ml-5 align-center"><h2 class="mx-2">{{ $t('date')+" : "  }}</h2><h2 class="ml-4 amber--text text--accent-2">{{new Date() | dateFormat('DD MMMM YYYY')}}</h2></v-row>
              <v-row class="ml-5 align-center"><h2 class="mx-2">{{ $t('total')+" : " }}</h2><h2 class="ml-8 amber--text text--accent-2">{{this.totalCart}}</h2></v-row>
              </v-card>
              </v-row>
          <v-divider class="ma-3"></v-divider>
          <v-row class="ml-5 align-center justify-center">
            <v-btn @click="confirmCart" class="ma-3 pa-2 success black--text font-weight-black" >{{ $t('confirm') }}</v-btn>
            <v-btn @click="confirmCartDialog=false" class="ma-3 pa-2 error black--text font-weight-black" >{{ $t('close') }}</v-btn>
            </v-row>
            </v-card>
            </v-row>
          </v-dialog>
  
  </v-card>
</v-container>
</template>

<script>
  export default {
      props:['selectedprods','client'],
    data () {
      return {
        dateVenta:"",
        shoplist:[],
        catactive:[],
        subcatactive:[],
        totalCart:0,
        qty:1,
        isTotal:false,
        logErrorInv:[],
        confirmCartDialog : false,
      }
    },
    mounted(){
        this.getTotal()
    },
    watch: {
        selectedprods:function(){
            if(!this.selectedprods.length){
                this.isTotal=false
            }else{this.getTotal()}
        }
  },
    computed:{
        
    },
    methods: {
      masQty(prod){
         if(prod.qty<prod.currenttInv){
        prod.qty+=1}
        this.getTotal()
      },
      minusQty(prod){
        if(prod.qty>0){
        prod.qty-=1}
        this.getTotal()
      },
        getTotal(){
            this.totalCart=0;
            this.logErrorInv=[]
            var total=0
            if(this.selectedprods.length){
            for(var i=0;i<this.selectedprods.length;i++){
              total = this.selectedprods[i].qty*this.selectedprods[i].pu
                this.selectedprods[i].total=total
                this.totalCart+=total
                
            }
            this.isTotal=true
            }
            this.$emit('total',this.totalCart)
        },
        removeProd(id){
            this.selectedprods.splice(id,1);
            this.getTotal();
            var qtyprod = this.selectedprods.length
            this.$emit('qtyprod',qtyprod)
        },
        confirmCart(){
        var clientName=this.client.name;
        var clientId=this.client.id;

        var total=this.totalCart;
        var products = this.selectedprods
        
        // ajoute l'item en verifiant l'id. si l'id existe, continue d'essayer jusqu'a trouver un id valide, 
        // permet de remplir les vides laisser par les suppressions precedentes
        var id = 'venta1';
            var ventadb = this.$store.state.sales;        
            if(ventadb.length>0){
              var size = ventadb.length
              var pos=1

               for(var i=0;i<size;i++){
                 if(ventadb[i].id!=id){continue}else{
                 pos+=1
                  id='venta'+pos
                  i=0
                }
            }
            }
            var date = new Date()
        
          var sale ={
            "id":id,
            "fecha":date,
            "clientName":clientName,
            "clientId":clientId,
            "total":total,
            "products":products
          }
        
          this.$store.dispatch('addSale',sale)
          this.confirmCartDialog=false;
          this.$emit('ventadone');
        
      },
        
    },
  }
</script>